import React, { Component } from 'react';
import { View, Text, Button, StyleSheet } from 'react-native';
import { Link } from 'react-router-dom';

import './style.css';
import * as ROUTES from '../../components/Navigation/routes';

import AuthContainer from '../../components/AuthContainer';

export default class index extends Component {


    render() {
        return (
            <AuthContainer>
                <View style={{ alignItems: 'center', padding: 50 }}>
                    <Text>Posters</Text>
                    <View style={{ flexDirection: 'row', flexWrap: 'wrap' }}>
                        <Link to={ROUTES.NEW_POSTER}><button className="posterButton">Publish New</button></Link>
                        <Link to={ROUTES.POSTERS}><button className="posterButton">View / Modify / Delete</button></Link>
                        <button className="posterButton" disabled>List All</button>
                        <button className="posterButton" disabled>Search Specific</button>
                    </View>
                </View>

            </AuthContainer>

        )
    }
}
